import React from "react";
import {ORGANIZATION_TYPES} from "../../../../utils/constants";
import {OptionButton} from "../../../../designSystem/components/OptionButton";

interface MedicalOrganizationCategoryButtonsProps {
  selected: string[];
  onChangeSelected: (type: object) => void;
}

export const MedicalOrganizationCategoryButtons = ({
  selected,
  onChangeSelected
}: MedicalOrganizationCategoryButtonsProps) => (
  <div className="flex gap-2 overflow-x-scroll p-2">
    {ORGANIZATION_TYPES
      .filter(type => type.name !== '不限')
      .map(type => (
        <OptionButton
          key={type.name}
          isSelected={selected.includes(type.name)}
          onClick={() => onChangeSelected(type)}
          icon={type.icon}
          label={type.name}
        />
      ))
    }
  </div>
)
